import React from 'react';

export const ClickAndCollectHandOverContext = React.createContext({
    shipments: [],
    selectedShipment: null,
    setSelectedShipment: (shipment) => {},
    zones: [],
    selectedZone: null,
    shippingMethods: [],
    setSelectedZone: (zone) => {},
    containers: [],
    selectedContainer: null,
    setSelectedContainer: (container) => {},
    searchString: '',
    setSearchString: (searchString) => {},
    onPageChange: (page) => {},
    getShipments: (link) => {},
    refreshShipments: () => {},
    nextLink: null,
    previousLink: null,
    totalPages: 0,
    sort: {
        orderBy: 'date',
        orderDirection: 'asc',
    },
    setSort: (sort) => {},
    openToast: () => {},
    handleRequestSort: (property) => {},
    setOpenHandOverScanShipmentPopup: (open) => {},
})
